<template>
  <svg v-if="alert" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.505.003a11.718 11.718 0 0 0-8.17 3.506 11.328 11.328 0 0 0-3.334 8.212c-.007 6.245 5.05 11.314 11.295 11.322h.239c6.411-.066 11.559-5.31 11.507-11.721C23.056 5.084 18.01.015 11.772 0c-.089 0-.178 0-.267.003zm-1.424 15.88a1.417 1.417 0 0 1 1.392-1.469h.025a1.466 1.466 0 0 1 1.463 1.411 1.416 1.416 0 0 1-1.392 1.47h-.025a1.468 1.468 0 0 1-1.463-1.412zm.48-3.88v-5.76a.96.96 0 1 1 1.92 0v5.76a.96.96 0 1 1-1.92 0z" fill="currentColor" fill-rule="nonzero"/></svg>
  <svg v-else-if="close" v-on="$listeners" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z" fill="currentColor"/><path d="M16.716 7.846l-.562-.562a.499.499 0 00-.705 0L12 10.733 8.551 7.284a.499.499 0 00-.705 0l-.562.562a.499.499 0 000 .705L10.733 12l-3.449 3.449a.499.499 0 000 .705l.562.562c.195.195.51.195.705 0L12 13.267l3.449 3.449c.195.195.51.195.705 0l.562-.562a.499.499 0 000-.705L13.267 12l3.449-3.449a.499.499 0 000-.705z" fill="#E7131C" fill-rule="evenodd"/></svg>
  <svg v-else-if="alarm" width="100%" viewBox="0 0 70 54" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
      <path class="outer" d="M57.812.92a3.143 3.143 0 00-4.369-.073 2.966 2.966 0 000 4.339c12.67 12.366 12.67 32.418.003 44.786l-.003.002a2.966 2.966 0 00-.001 4.267 3.144 3.144 0 004.37.001C72.895 39.52 72.896 15.65 57.816.925L57.812.92z"/>
      <path class="inner" d="M49.59 9.538c-1.196-1.133-3.041-1.032-4.12.224a3.175 3.175 0 00.01 4.112c7.406 7.773 7.406 20.375 0 28.148-1.14 1.197-1.14 3.136 0 4.332a2.823 2.823 0 004.128-.002c9.688-10.164 9.69-26.644.004-36.81a1.057 1.057 0 01-.004-.004h-.017z"/>
      <path class="outer" d="M5.87 27.546c-.023-8.416 3.226-16.492 9.02-22.428a3.084 3.084 0 00-.072-4.27 2.873 2.873 0 00-4.076 0C-3.58 15.59-3.581 39.493 10.738 54.237l.004.004a2.875 2.875 0 004.15-.002 3.084 3.084 0 00-.002-4.271C9.095 44.034 5.846 35.96 5.87 27.546z"/>
      <path class="inner" d="M23.646 9.646a2.828 2.828 0 00-4.128-.003l-.002.003c-9.688 10.137-9.688 26.571 0 36.709a2.829 2.829 0 004.128.001c1.14-1.192 1.141-3.127.002-4.32-7.41-7.752-7.41-20.32-.002-28.073l.002-.002c1.137-1.192 1.137-3.123 0-4.315z"/>
      <path class="dot" d="M34.563 35a7.438 7.438 0 100-14.875 7.438 7.438 0 000 14.875z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    alert: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    alarm: {
      type: Boolean,
      default: false
    }
  }
};
</script>
